import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, Image,
    Text

} from "react-native";

export default class BClass extends Component {
    constructor(props) {
        super();
        this.state = {...props};
    }

    componentWillMount() {
      //  window.location = this.state.route.loc;
    }

    render() {
        return (<View>
            <Text style={{color: "#0021ee", fontSize: 80}}>
                B
            </Text>
        </View>);
    }
}

